export function scheduleWhenIdle(
  callback: () => void,
  timeoutMs = 4000
): void {
  if (typeof globalThis.requestIdleCallback === 'function') {
    globalThis.requestIdleCallback(() => callback(), { timeout: timeoutMs });
    return;
  }

  setTimeout(callback, timeoutMs);
}
